module.exports = __webpack_public_path__ + "static/img/onOff.fdfd5cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onOff.gif
// module id = 284
// module chunks = 1